import { bb } from "$json";
/* previews-autoload-first:
 *
 * Autoload the first preview document, delete rest.
 *
 * It implements a part the functionality provided last-template in a
 * native fashion and should replace that plugin once all models using
 * last-template have been adjusted.
 *
 * @dependencies: previews
 *
 * @todo: rename class bb-p-last-template-missing (needs fix in CSS
 * too - which we'll do after model fixes).
 *
 */

(function ($) {
  $(document).on("bb:preHandleData", function (event, data) {
    if (data.documents && data.documents.length) {
      var doc = data.documents[0],
        template = doc.document,
        name = doc.name;

      data.documents = [];

      $(".panel-3").removeClass("bb-p-last-template-missing");
      $("#bb-p-previews-name").text(name);

      bb.Plugins.previews.reload(
        "preview?" +
          $.param({
            uniqueid: data.uniqueid,
            sessionid: data.sessionid,
            dbname: data.dbname,
            template: template
          }),
        name
      );
      bb.Mode.set("hasPreviews");
    } else {
      $(".panel-3").addClass("bb-p-last-template-missing");
      bb.Mode.unset("hasPreviews"); // Cause it's been removed.
    }
  });
})(jQuery);
